export default __webpack_public_path__ + "static/media/quantisal_step7.b6af0b90.png";